import cn from 'clsx'
import s from './ScanSection.module.scss'
import { FC, useRef } from 'react'
import { Text, CustomImage, Container, Button } from '@components/ui'
import { useWindowSize } from '@hooks/useWindowSize'

import { LoreThreeDetailPageSectionsInner } from '@generated/model/loreThreeDetailPageSectionsInner'
import { CustomImageProps } from '@components/ui/CustomImage/CustomImage'

type ScanSectionProps = {
  section: LoreThreeDetailPageSectionsInner
}

const ScanSection: FC<ScanSectionProps> = ({ section }) => {
  return (
    <>
      <div className={s.root}>
        {section.image && (
          <div className={s.image}>
            <CustomImage data={section as unknown as CustomImageProps} />
          </div>
        )}
        {section.title && (
          <Text className={s.title} variant="heading">
            {section.title}
          </Text>
        )}

        {section.detail && (
          <Text
            className={s.detail}
            html={section.detail}
            variant="smallText"
          />
        )}
      </div>
    </>
  )
}

export default ScanSection
